import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AccEmploymentFormGroup } from '../../form-groups/acc-employment.formgroup';
import { AccWorkCapacityFormGroup } from '../../form-groups/acc-work-capacity.formgroup';
import { AccEmploymentFormComponent } from '../../form-components/acc-employment-form/acc-employment-form.component';
import { AccWorkCapacityFormComponent } from '../../form-components/acc-work-capacity-form/acc-work-capacity-form.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'pr-acc-employment-step',
  imports: [
    CommonModule,
    AccEmploymentFormComponent,
    AccWorkCapacityFormComponent,
  ],
  templateUrl: './acc-employment-step.component.html',
  styleUrl: './acc-employment-step.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccEmploymentStepComponent {
  employmentForm = input.required<AccEmploymentFormGroup>();
  workCapacityForm = input.required<AccWorkCapacityFormGroup>();
  disabled = input<boolean>(false);
}
